import moment from 'moment';

export default {
  enrichEmployees(employees) {
    return employees.map((employee) => ({
      ...employee,
      _fullName: `${employee.name} ${employee.surname}`,
      _initials: employee.name.charAt(0) + employee.surname.charAt(0),
    }));
  },

  formatDateTime(date) {
    moment(date);
    return moment(date).format('DD.MM.yyyy, HH:mm');
  },

  formatTimeblockDateTime(timeblock) {
    // Handle new format with separate date and time fields
    if (timeblock.date && timeblock.starts_at_time) {
      const dateStr = moment(timeblock.date).format('DD.MM.yyyy');
      return `${dateStr}, ${timeblock.starts_at_time}`;
    }
    // Fallback to old format
    if (timeblock.start) {
      return this.formatDateTime(timeblock.start);
    }
    return '';
  },

  formatDateTimeForBackend(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  },

  formatDate(date) {
    return moment(date).format('DD.MM.yyyy');
  },

  isBefore(date, compareTo = null) {
    return moment(date).isBefore(moment(compareTo));
  },

  isAfter(date, compareTo = moment()) {
    return moment(date).isAfter(moment(compareTo));
  },
};
